import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero, hide if near the bottom pricing section
      const scrollY = window.scrollY;
      const pricingSection = document.getElementById('pricing');
      const pricingTop = pricingSection ? pricingSection.offsetTop - 800 : Infinity;
      setIsVisible(scrollY > 600 && scrollY < pricingTop);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-215">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-carbon-950/90 backdrop-blur-md border-t border-carbon-800" data-id="element-216">
          <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-217">
            <div className="text-center sm:text-left hidden md:block" data-id="element-218">
              <p className="font-mono text-xs text-carbon-400 uppercase tracking-widest" data-id="element-219">
                El sistema completo
              </p>
              <p className="font-display text-xl text-white uppercase tracking-wide mt-1" data-id="element-220">
                MÉTODO HYBRID 360
              </p>
            </div>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-electric hover:bg-electric-hover text-carbon-950 px-6 py-3 rounded-full flex items-center justify-center gap-3 transition-all group" data-id="element-221">
              <span className="font-display text-xl tracking-wide uppercase" data-id="element-222">
                QUIERO EL MÉTODO
              </span>
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" strokeWidth={2.5} data-id="element-223" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}